export const formatHoursAndMinutesToTimeFormat = (
  hours: number,
  minutes: number
) => {
  return `${hours.toString().padStart(2, '0')}h ${minutes
    .toString()
    .padStart(2, '0')}m`;
};
